import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Sets an Speed Coaching Profile as default or not
 * @param Id ID of the Speed Coaching Profile
 * @param defaultSet Whether the Speed Coaching Profile will be set as default
 */
export function putSpeedCoachingProfileDefault(
  this: unknown,
  id: number,
  defaultSet: boolean
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment
          .resolve(this)
          .speedCoachingIdDefaultUrl(id)}/${defaultSet.toString()}`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
        message: z.string(),
      })
    )
  );
}
